import React, { useState, useEffect, useRef } from 'react';
import {
  getVehicleRequest,
  getQuotationListRequest,
  deleteQuotation,
  editQuotation,
  createQuotation,
  getVehicleDetailRequestReport,
  getFullRunningVehicleReportTwo,
  getFullRunningVehicleReportThree,
} from '../../services/vm/apiController';
import { Link, useParams } from 'react-router-dom';
import { formatDate } from '../../util/helper';
import { DeleteIcon, DownloadIcon, EditIcon, ViewIcon } from './components/icons';
import { toast, ToastContainer } from 'react-toastify';
import { destroy } from '../../services/apiController';
import { TABLE_DEFAULT_LIMIT } from '../../util/constant';
import { Table, Modal, Button, Form, FloatingLabel, Row, Col, Alert } from 'react-bootstrap';
import 'react-toastify/dist/ReactToastify.css';
import AlertIcon from '../../img.svg';
import PaginationInPage from '../Pagination';

const VehicleRequestDetails = (props) => {
  const formFields = {
    name: '',
    price: '',
    description: '',
    gst: '',
    contact: '',
    email: '',
    contactPerson: '',
    address: '',
    file1: null,
    fileName1: '',
    file2: null,
    fileName2: '',
  };

  const [requestDetail, setRequestDetail] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [quotationList, setQuotationList] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [quotationForm, setQuotationForm] = useState(formFields);
  let params = useParams();
  const [show, setShow] = useState(false);
  const [validated, setValidated] = useState(false);
  const [vendorName, setVendorName] = useState('');
  const [documentShowConfirmModel, setDocumentShowConfirmModel] = useState(false);
  const handleCloseDocumentConfirmModal = () => {
    setDocumentShowConfirmModel(false);
  };
  const [fieldToDeleted, setFieldToDeleted] = useState('');
  const [showConfirmModel, setShowConfirmModel] = useState(false);
  const handleCloseConfirmModal = () => {
    setShowConfirmModel(false);
  };
  const [quotationIdToDeleted, setQuotationIdToDeleted] = useState('');
  const [vehicleIdToDeleted, setVehicleIdToDeleted] = useState('');
  const clickToDownload = useRef(null);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);

  const handleShow = () => {
    setShow(true);
    setValidated(false);
    setQuotationForm(formFields);
  };
  const handleClose = () => setShow(false);

  const handleShowDocumentConfirmModal = (e, field) => {
    e.preventDefault();
    setDocumentShowConfirmModel(true);
    setFieldToDeleted(field);
  };

  const handleShowConfirmModal = (e, quotationId, vehicleRequestId) => {
    e.preventDefault();
    setShowConfirmModel(true);
    setQuotationIdToDeleted(quotationId);
    setVehicleIdToDeleted(vehicleRequestId);
  };

  const handleChange = (e) => {
    e.preventDefault();
    let name = e.target.name;
    let value = e.target.value;
    setQuotationForm({ ...quotationForm, [name]: value });
  };

  const onChangeDocumentOne = (e) => {
    const file = e.target.files[0];
    if (file && file.name.match(/\.(exe|apk|bat|cmd|com|dll|jar|msi|py|sh)$/)) {
      e.target.value = ''; // Clear the selected file
      toast.error('Please select a valid file type.', { autoClose: 2000 });
    } else {
      setQuotationForm({ ...quotationForm, file1: file || null, fileName1: file?.name || '' });
    }
  };

  const onChangeDocumentTwo = (e) => {
    const file = e.target.files[0];
    if (file && file.name.match(/\.(exe|apk|bat|cmd|com|dll|jar|msi|py|sh)$/)) {
      e.target.value = ''; // Clear the selected file
      toast.error('Please select a valid file type.', { autoClose: 2000 });
    } else {
      setQuotationForm({ ...quotationForm, file2: file || null, fileName2: file?.name || '' });
    }
  };

  const getQuotationRequest = async (limit = TABLE_DEFAULT_LIMIT, offset = 0, quotationId = 0) => {
    try {
      let condition = {
        name: vendorName || '',
      };
      const quotationList = await getQuotationListRequest(offset, limit, condition, params.id, quotationId);
      return quotationId === 0
        ? {
            data: (quotationList && quotationList.data.rows) || [],
            totalRecords: (quotationList && quotationList.data && quotationList.data.count) || 0,
          }
        : {
            data: (quotationList && quotationList.data) || [],
          };
    } catch (e) {
      console.error(e);
      return {
        errorMessage: e.message,
      };
    }
  };

  useEffect(() => {
    getVR();
  }, []);

  const getVR = async () => {
    const vehicleRequest = await getVehicleRequest(params.id);
    setRequestDetail(vehicleRequest.data);
    const quotationsVehicleRequest = await getQuotationRequest(TABLE_DEFAULT_LIMIT, currentPage);
    setTotalRecords(quotationsVehicleRequest.totalRecords);
    setQuotationList(quotationsVehicleRequest.data);
  };

  async function getRequests() {
    const quotationsVehicleRequest = await getQuotationRequest(TABLE_DEFAULT_LIMIT, currentPage);
    setTotalRecords(quotationsVehicleRequest.totalRecords);
    setQuotationList(quotationsVehicleRequest.data);
  }
  useEffect(() => {
    getRequests();
  }, [currentPage]);

  const editQuotationRequest = async (e, id) => {
    e.preventDefault();
    const getSingleQuotation = async () => {
      const data = await getQuotationRequest(TABLE_DEFAULT_LIMIT, currentPage, id);
      setQuotationForm(data.data);
    };
    getSingleQuotation();
    setShow(true);
  };

  const deleteFile = (field) => {
    try {
      destroy(`/vm/vehicle-requests/${params.id}/filefrom/${field}`)
        .then((resp) => {
          setRequestDetail(resp.data);
          setDocumentShowConfirmModel(false);
        })
        .catch((error) => {
          toast.error(error.message);
        });
    } catch (e) {
      toast.error(e.message);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    for (var key in quotationForm) {
      if (key === 'file1' || key === 'fileName1' || key === 'file2' || key === 'fileName2') continue;
      formData.append(key, quotationForm[key]);
    }
    if (quotationForm.file1 !== null && typeof quotationForm.file1 !== 'string')
      formData.append('file1', quotationForm['file1'], quotationForm.fileName1);
    if (quotationForm.file2 !== null && typeof quotationForm.file2 !== 'string')
      formData.append('file2', quotationForm['file2'], quotationForm.fileName2);
    if (formData.get('id') && formData.get('id') !== null) {
      try {
        setIsButtonDisabled(false);
        await editQuotation(formData, requestDetail.id, formData.get('id'));
        toast.success('Quotation updated successfully');
        setShow(false);
        getRequests();
      } catch (err) {
        toast.error(err?.response?.data?.data?.message || err?.message || 'Something went wrong', { autoClose: 2000 });
      }
    } else {
      if (isButtonDisabled) {
        return; // If button is disabled, return early
      }
      setIsButtonDisabled(true); // Disable the button
      try {
        await createQuotation(formData, requestDetail.id);
        toast.success('Quotation added successfully');
        setShow(false);
        getRequests();
      } catch (err) {
        toast.error(err?.response?.data?.data?.message || err?.message || 'Something went wrong', { autoClose: 2000 });
      } finally {
        // Enable the button after a delay of 3 seconds
        setTimeout(() => {
          setIsButtonDisabled(false);
        }, 500);
      }
    }
  };

  const handleRemove = (event, quotationId, requestId) => {
    event.preventDefault();
    const deleteQuotat = async () => {
      try {
        const data = await deleteQuotation(quotationId, requestId);
        toast.success(data.data);
        setShowConfirmModel(false);
        getRequests();
      } catch (err) {
        toast.error(err?.response?.data?.data?.message || 'Something went wrong', { autoClose: 2000 });
      }
    };
    deleteQuotat();
  };

  const handleDownload = async (e) => {
    e.preventDefault();
    try {
      const data = await getVehicleDetailRequestReport(params.id);
      if (data.data) {
        clickToDownload.current.href = `${process.env.REACT_APP_BASE_URL}/file/download?filePath=` + data.data;
        setTimeout(() => {
          clickToDownload.current.click();
        }, 500);
      }
    } catch (err) {
      console.error(err);
      toast.error(err.message);
    }
  };

  const handleDownloadTwo = async (e, isRunningVehicle) => {
    e.preventDefault();
    try {
      const data = await getFullRunningVehicleReportTwo(requestDetail.id, isRunningVehicle);
      if (data.data) {
        clickToDownload.current.href = `${process.env.REACT_APP_BASE_URL}/file/download?filePath=` + data.data;
        setTimeout(() => {
          clickToDownload.current.click();
        }, 500);
      }
    } catch (err) {
      console.error(err);
      toast.error(err.message);
    }
  };

  const handleDownloadThree = async (e) => {
    e.preventDefault();
    try {
      const data = await getFullRunningVehicleReportThree(requestDetail.id);
      if (data.data) {
        clickToDownload.current.href = `${process.env.REACT_APP_BASE_URL}/file/download?filePath=` + data.data;
        setTimeout(() => {
          clickToDownload.current.click();
        }, 500);
      }
    } catch (err) {
      console.error(err);
      toast.error(err.message);
    }
  };

  return (
    <React.Fragment>
      <ToastContainer />
      <nav className="" aria-label="breadcrumb">
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <Link to="/vm/vehicle-requests">Vehicle Request List</Link>
          </li>
          <li className="breadcrumb-item">
            <Link to={`/vm/vehicle-requests/${requestDetail.id}`}>Vehicle Request Detail</Link>
          </li>
        </ol>
      </nav>
      <div className="card">
        <div className="card-header white-color" style={{ padding: '1rem 1.7rem' }}>
          <h4 className="card-title mb-0" style={{ fontSize: '16px' }}>
            Vehicle Request Detail
          </h4>
          <a ref={clickToDownload} href="" target="_blank" className="hiddenItem">
            HiddenClick
          </a>
          {requestDetail.status !== 'RUNNING VEHICLE' && requestDetail.status !== 'PO REQUESTED' ? (
            <button type="button" onClick={(e) => handleDownloadThree(e)} className="btn app-btn-default dark-color">
              Download Report
            </button>
          ) : (
            ''
          )}
          {requestDetail.isRunning == false && requestDetail.status == 'RUNNING VEHICLE' ? (
            <button type="button" onClick={(e) => handleDownload(e)} className="btn app-btn-default dark-color">
              Download Report
            </button>
          ) : (
            ''
          )}
          {requestDetail.isRunning == true && requestDetail.status == 'RUNNING VEHICLE' ? (
            <button type="button" onClick={(e) => handleDownloadTwo(e, 'isRunningVehicle')} className="btn app-btn-default dark-color 2">
              Download Report2
            </button>
          ) : (
            ''
          )}
        </div>
        <div className="card-body">
          <Row className="top-row">
            <div className="col-md-2">
              <dd className="display-title mb-1">Vehicle Name</dd>
              <dt className="display-value">{requestDetail.model}</dt>
            </div>
            <div className="col-md-2">
              <dd className="display-title mb-1">Status</dd>
              <dt className="display-value">{requestDetail.status}</dt>
            </div>
            <div className="col-md-2">
              <dd className="display-title mb-1">Requested Date</dd>
              <dt className="display-value">{formatDate(requestDetail.requestedDate)}</dt>
            </div>
            <div className="col-md-2">
              <dd className="display-title mb-1">Requested By</dd>
              <dt className="display-value">{requestDetail.requestedBy}</dt>
            </div>
            <div className="col-md-2">
              <dd className="display-title mb-1">Initiated By</dd>
              <dt className="display-value">{requestDetail.initiatedBy}</dt>
            </div>
          </Row>
          <Row className="top-row">
            <Col xs={12}>
              <dd className="display-title mb-1">Reason</dd>
              <dt className="display-value">{requestDetail.reason}</dt>
            </Col>
          </Row>
          <Row>
            <Col xs={4}>
              <h6>Downloads</h6>
              {(requestDetail.file1 || requestDetail.file2) && (
                <ul className="list-group">
                  {requestDetail.file1 && (
                    <li className="list-group-item">
                      <Row>
                        <Col xs={8} className="file-name">
                          {requestDetail.file1Name}
                        </Col>
                        <Col xs={4} className="text-end actions">
                          <a href={`${process.env.REACT_APP_BASE_URL}/file/download?filePath=${requestDetail.file1}`}>
                            <DownloadIcon />
                          </a>
                          <DeleteIcon
                            onClick={(e) => handleShowDocumentConfirmModal(e, 'file1')}
                            style={{ color: 'rgb(220, 53, 69)', cursor: 'pointer' }}
                          />
                        </Col>
                      </Row>
                    </li>
                  )}
                  {requestDetail.file2 && (
                    <li className="list-group-item">
                      <Row>
                        <Col xs={8} className="file-name">
                          {requestDetail.file2Name}
                        </Col>
                        <Col xs={4} className="text-end actions">
                          <a href={`${process.env.REACT_APP_BASE_URL}/file/download?filePath=${requestDetail.file2}`}>
                            <DownloadIcon />
                          </a>
                          <DeleteIcon
                            onClick={(e) => handleShowDocumentConfirmModal(e, 'file2')}
                            style={{ color: 'rgb(220, 53, 69)', cursor: 'pointer' }}
                          />
                        </Col>
                      </Row>
                    </li>
                  )}
                </ul>
              )}
            </Col>
          </Row>
        </div>
      </div>
      {requestDetail.isRunning == false ? (
        <>
          <div className="row mb-2">
            <div className="form-group col-md-4 col-lg-4">
              <input
                type="text"
                className="form-control mt-5"
                id="exampleInputEmail1"
                placeholder="Please enter vendor Name"
                aria-describedby="emailHelp"
                value={vendorName}
                onChange={(e) => {
                  setVendorName(e.target.value);
                }}
              />
            </div>
            <div className="form-group col-md-8 col-lg-8">
              <div className="btn-wrapper justify-content-start">
                <button type="button" className="btn app-btn-primary mt-5" onClick={getRequests}>
                  Search
                </button>
              </div>
            </div>
          </div>
          <div className="card">
            <div className="card-header white-color" style={{ padding: '1rem 1.7rem' }}>
              <h4 className="card-title mb-0" style={{ fontSize: '16px' }}>
                Quotations | {totalRecords ?? 0}
              </h4>
              <button type="button" className="btn app-btn-default dark-color" onClick={handleShow}>
                Add Quotation
              </button>
            </div>
            <div className="card-body px-0 vehicle-requests-table pt-0 pb-0">
              <div className="row">
                <div className="col">
                  <Table responsive striped>
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Vendor Name</th>
                        <th>Price</th>
                        <th>Description</th>
                        <th>Status</th>
                        <th>Created Date</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {quotationList?.map((request, index) => {
                        return (
                          <tr key={request.id} className={request.isDeleted == true ? 'disabled-tr' : ''}>
                            <td>{(currentPage - 1) * TABLE_DEFAULT_LIMIT + (index + 1)}</td>
                            <td>{request.name}</td>
                            <td>{request.price}</td>
                            <td>{request.description}</td>
                            <td>{request.status}</td>
                            <td>{formatDate(request.createdAt)}</td>
                            <td className="actions">
                              <Link to={`/vm/vehicle-requests/${params.id}/quotations/${request.id}`}>
                                <ViewIcon />
                              </Link>
                              &nbsp;&nbsp;
                              <span style={{ cursor: 'pointer' }} onClick={(event) => editQuotationRequest(event, request.id)}>
                                <EditIcon />
                              </span>
                              &nbsp;&nbsp;
                              <Link onClick={(e) => handleShowConfirmModal(e, request.id, requestDetail.id)} to="/">
                                <DeleteIcon />
                              </Link>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </Table>
                  <PaginationInPage
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                    totalRecords={totalRecords}
                    TABLE_DEFAULT_LIMIT={TABLE_DEFAULT_LIMIT}
                  />
                </div>
              </div>
            </div>
          </div>
        </>
      ) : (
        ''
      )}
      <Modal size="lg" show={show} backdrop="static" keyboard={false} className="request-modal">
        <Modal.Header>
          <Modal.Title>{!Object.keys(quotationForm).includes('id') ? 'Add Quotation' : 'Edit Quotation'}</Modal.Title>
          <button type="button" className="btn-close" aria-label="Close" onClick={handleClose}></button>
        </Modal.Header>
        <Modal.Body>
          <Form noValidate validated={validated}>
            <Row>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Vendor Name" className="mb-3">
                  <Form.Control
                    onChange={handleChange}
                    value={quotationForm.name}
                    className="input"
                    name="name"
                    type="text"
                    placeholder="name@example.com"
                    required
                  />
                </FloatingLabel>
              </Col>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Price" className="mb-3">
                  <Form.Control
                    onChange={handleChange}
                    value={quotationForm.price}
                    className="input"
                    name="price"
                    type="number"
                    placeholder="name@example.com"
                    required
                  />
                </FloatingLabel>
              </Col>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Description" className="mb-3">
                  <Form.Control
                    onChange={handleChange}
                    value={quotationForm.description}
                    className="input"
                    name="description"
                    type="text"
                    placeholder="name@example.com"
                    required
                  />
                </FloatingLabel>
              </Col>
            </Row>
            <Row>
              <Col xs={4} className="requested-date">
                <FloatingLabel controlId="floatingInput" label="GST" className="mb-3">
                  <Form.Control
                    onChange={handleChange}
                    value={quotationForm.gst}
                    className="input"
                    name="gst"
                    type="text"
                    placeholder="name@example.com"
                    required
                  />
                </FloatingLabel>
              </Col>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Contact Number" className="mb-3">
                  <Form.Control
                    onChange={handleChange}
                    value={quotationForm.contact}
                    className="input"
                    name="contact"
                    type="number"
                    placeholder="name@example.com"
                    required
                  />
                </FloatingLabel>
              </Col>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Email" className="mb-3">
                  <Form.Control
                    onChange={handleChange}
                    value={quotationForm.email}
                    className="input"
                    name="email"
                    type="text"
                    placeholder="name@example.com"
                    required
                  />
                </FloatingLabel>
              </Col>
            </Row>
            <Row className="mb-4">
              <Col xs={4} className="requested-date">
                <FloatingLabel controlId="floatingInput" label="Contact Person" className="mb-3">
                  <Form.Control
                    onChange={handleChange}
                    value={quotationForm.contactPerson}
                    className="input"
                    name="contactPerson"
                    type="text"
                    placeholder="name@example.com"
                    required
                  />
                </FloatingLabel>
              </Col>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Address" className="mb-3">
                  <Form.Control
                    onChange={handleChange}
                    value={quotationForm.address}
                    className="input"
                    name="address"
                    type="text"
                    placeholder="name@example.com"
                    required
                  />
                </FloatingLabel>
              </Col>
            </Row>
            <Row className="bottom-content">
              <Col xs={12}>
                <Alert.Heading>Quotation Documents</Alert.Heading>
                <hr />
              </Col>
              <Col xs={6}>
                <Form.Group controlId="formFile" className="mb-3">
                  <Form.Label>Document 1</Form.Label>
                  <Form.Control onChange={onChangeDocumentOne} type="file" name="file1" aria-required="false" />
                  {quotationForm.fileName1 !== null ? <p className="mb-0">{quotationForm.fileName1}</p> : ''}
                </Form.Group>
              </Col>
              <Col xs={6}>
                <Form.Group controlId="formFile" className="mb-3">
                  <Form.Label>Document 2</Form.Label>
                  <Form.Control onChange={onChangeDocumentTwo} type="file" name="file2" aria-required="false" />
                  {quotationForm.fileName2 !== null ? <p className="mb-0">{quotationForm.fileName2}</p> : ''}
                </Form.Group>
              </Col>
            </Row>
            <Button onClick={handleSubmit} type="submit" className="add-request-btn mt-4 mb-3" disabled={isButtonDisabled}>
              {!Object.keys(quotationForm).includes('id') ? 'Add Quotation' : 'Update Quotation'}
            </Button>
          </Form>
        </Modal.Body>
      </Modal>
      <Modal size="sm" show={documentShowConfirmModel} backdrop="static" keyboard={false} className="request-modal">
        <Modal.Header className="bg-danger text-light py-2">
          <Modal.Title>Delete Document</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex justify-content-start">
            <img src={AlertIcon} />
            <p className="ps-3 mb-0">Are you sure? Action cannot be undone.</p>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="btn-wrapper">
            <button onClick={handleCloseDocumentConfirmModal} className="btn app-btn-default btn-sm">
              Cancel
            </button>
            <button onClick={() => deleteFile(fieldToDeleted)} className="btn app-btn-danger btn-sm">
              Delete
            </button>
          </div>
        </Modal.Footer>
      </Modal>
      <Modal size="sm" show={showConfirmModel} backdrop="static" keyboard={false} className="request-modal">
        <Modal.Header className="bg-danger text-light py-2">
          <Modal.Title>Quotation</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex justify-content-start">
            <img src={AlertIcon} alt="Alert" />
            <p className="ps-3 mb-0">Are you sure? Action cannot be undone.</p>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="btn-wrapper">
            <button onClick={handleCloseConfirmModal} className="btn app-btn-default btn-sm">
              Cancel
            </button>
            <button
              onClick={(event) => handleRemove(event, quotationIdToDeleted, vehicleIdToDeleted)}
              className="btn app-btn-danger btn-sm"
            >
              Delete
            </button>
          </div>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
};

export default VehicleRequestDetails;
